module.exports = __webpack_public_path__ + "img/เนื้อหมูป่า.d9a020d3.jpg";